import { useSetAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { createBreadcrumbWithI18n } from '~/apps/ninesegsAnalyzer/routes/paths'
import { Box } from '~/components/elements/Box'
import {
  PageContainer,
  type PageContainerProps,
} from '~/components/elements/PageContainer'
import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import { VStack } from '~/components/elements/VStack'

import { dialogInfoAtom } from '../atoms'
import { useBrandAccountId } from '../hooks/useBrandAccountId'
import { useMainQuerySurveyGroups } from '../hooks/useMainQuery'

import { Dialogs } from './Dialogs'
import { SurveyGroupListItem } from './SurveyGroupListItem'

export const TimeSeriesSettings = () => {
  const { t } = useTranslation()
  const brandAccountId = useBrandAccountId()
  const createBreadcrumb = React.useMemo(() => createBreadcrumbWithI18n(t), [t])
  const breadcrumbs = React.useMemo<PageContainerProps['breadcrumbs']>(
    () => [
      createBreadcrumb('top', {}),
      createBreadcrumb('timeSeriesReport'),
      createBreadcrumb('timeSeriesSettings', { brandAccountId }),
    ],
    [brandAccountId, createBreadcrumb],
  )

  const surveyGroups = useMainQuerySurveyGroups()

  const setDialogInfo = useSetAtom(dialogInfoAtom)
  const handleAddButtonClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    setDialogInfo({ dialogType: 'create' })
  }, [setDialogInfo])

  return (
    <PageContainer breadcrumbs={breadcrumbs}>
      <VStack spacing={0}>
        <Box padding={2}>
          <StyledButton icon="add" onClick={handleAddButtonClick}>
            {t('add_survey_group')}
          </StyledButton>
        </Box>

        {surveyGroups.map((surveyGroup) => (
          <SurveyGroupListItem key={surveyGroup.id} surveyGroup={surveyGroup} />
        ))}

        <Dialogs />
      </VStack>
    </PageContainer>
  )
}
